import springbok_image from '../src/assets/SBAvatar.png'
import springbok_bot_image from '../src/assets/SBAvatarCopy.png'
import userAvatar from '../src/assets/userAvi.svg'
import notificationPing from '../src/assets/notification.mp3'

export const dataset_defaults = {
    timeout: 8000, 
    max_bot_response_delay_ms: 1000, 
    chat_origin: '',
    initial_payload: null,
    chat_persistence: 'false',
    read_more_cut_off: 10000,
    notification_sound: notificationPing,
    style_endpoint: null,
    tenant_id: '00000000-00000000-00000000-00000000',

    // widget starter toggle setup
    external_control: 'false',
    external_open: 'false',

    // Logos
    big_bot_avatar_url: springbok_image,
    mini_bot_avatar_url: springbok_bot_image,
    user_avatar_url: userAvatar,
    header_logo: springbok_image,

    // Styling
    font: 'Verdana',
    title: 'Springbot',
    height: '331px', // represents the height of the main section, the full widget height has + 60px x2 for header & input
    width: '370px',
    avatar_bg_color: 'transparent',
    header_bg_color: '#13063b',
    header_text_color: 'white',
    header_button_bg_color: 'lightskyblue',
    header_button_text_color: 'white',
    chat_bg_color: 'white',
    user_bg_color: '#D4E1F6',
    user_text_color: 'black',
    bot_bg_color: '#EBF7F7',
    bot_text_color: 'black',
    bot_hyperlink_color: '#03737B',
    scrollbar_thumb_color: '#13063b',
    scrollbar_track_color: 'white',
    read_more_bg_color: '#AFDEFB',
    read_more_text_color: 'black',
    buttons_bg_color: '#43B7FF',
    buttons_text_color: 'black',
    send_icon_color: '#13063b',
    quick_replies_bg_color: 'orange',
    quick_replies_text_color: 'black',

    // coverpage styles
    cover_page_hyperlink_color: 'pink', 
    cover_page_start_btn_color: 'navy',
    cover_page_start_btn_text_color: 'white',
    cover_page_background_color: 'white',
    cover_page_text_color: 'navy',
    cover_page_dropdown_bg_color: 'grey',
    cover_page_dropdown_text_color: 'white',

    // Feature toggles and attributes
    use_menu: 'true',
    page_layout: 'false',
    open_links_new_tab: 'true',
    remote_config_url: null,
    terms_link: '', // if blank, the page doesn't reload, it just doesn't link anywhere
    privacy_link: '', // as above
    //powered_by_link: 'https://accesscharity.org.uk/',
    // below are example menu items
    // menu_items: [
    //     { title: 'Safeguarding', contentful_id: '4mXcij81ujRLNkVc0EwzrZ ' },
    //     { title: 'Moving House', contentful_id: 'someid' },
    //     { title: 'Post-Hospital Care', contentful_id: 'someid' },
    //     { title: 'Home Care', contentful_id: 'someid' },
    //     { title: 'Funding', contentful_id: 'someid' },
    //     { title: 'Another Example', contentful_id: 'someid' },
    // ],

    // Inactive popup toggles
    use_inactive_popup: 'false',
    inactive_popup_text: 'Chat to me, this is some example text.',
    inactive_popup_border_color: 'black',
    inactive_popup_bg_color: 'white',
    inactive_popup_text_color: 'black',
    inactive_popup_close_color: 'black',

    // For Email transcript option in menu
    transcript_intent: '/transcript',
    transcript_slot: 'email',

    // For checking endpoints
    health_check: 'false',
    health_check_endpoints: null,
    hide_on_health_check_fail: 'true',
}